import { ViewController } from '@estee/elc-service';
import { UserRepository } from '../../repositories/UserRepository';
import { diContainer, serviceNames } from '../../../service-setup/diContainer';
import { computed } from 'mobx';
import { ConfigRepository } from '../../repositories/ConfigRepository';
import { handlePlaceholderValues } from '../../utils/FormatText';
import { FieldValidations } from '../../utils/FieldValidations';
import { TranslationRepository } from '../../repositories/TranslationRepository';

export class QRCodeViewController extends ViewController {
    public userRepository: UserRepository;
    public configRepository: ConfigRepository;
    public translationRepository: TranslationRepository;

    constructor() {
        super();
        this.userRepository = diContainer.get(serviceNames.userRepository);
        this.configRepository = diContainer.get(serviceNames.configRepository);
        this.translationRepository = diContainer.get(serviceNames.translationRepository);
    }

    @computed
    public get passwordValidations(): FieldValidations {
        const { fieldsValidations } = this.configRepository.rampConfig || {};
        if (!fieldsValidations?.password) {
            return new FieldValidations();
        }
        const { translations } = this.translationRepository;
        const config = fieldsValidations.password;

        const fieldValidations = new FieldValidations({
            ...config,
            errorMessages: {
                required: 'passwordRequiredMessage',
                default: 'passwordStrengthFailedResetPasswordError'
            },
            translations
        });

        return fieldValidations;
    }

    @computed
    public get data() {
        const {
            userId,
            frontierErrorMessage,
            onlineSignUpFormStore: { values }
        } = this.userRepository;
        const { mobile, name, email } = this.configRepository.userInfoDisplay;

        return {
            userId,
            frontierErrorMessage,
            passwordValidations: this.passwordValidations,
            userMobile: handlePlaceholderValues(mobile, values, true),
            userName: handlePlaceholderValues(name, values, true),
            userEmail: handlePlaceholderValues(email, values, true)
        };
    }
}
